import { Avatar, Box, Stack, Typography, useMediaQuery } from "@mui/material"
import { AvatarStyle, MainStack, TypReplies } from "./style";
import { PureLightTheme } from "../../../../styles/theme";
import { RepliesSummaryProps } from "../../../../types";

export const RepliesSummary = ({repliesSummary}: RepliesSummaryProps) => {
    const isMobile = useMediaQuery(PureLightTheme.breakpoints.down("sm"))

    return (
        <Stack direction="row" alignItems="center" sx={MainStack}>
            <Avatar src={repliesSummary.firstReplyAuthor.avatarUrl} sx={AvatarStyle} />
            <Stack direction="row" gap={1}>
                <Typography variant="pictonBlue-12-normal" sx={TypReplies}>
                    <Box component="span">{repliesSummary.firstReplyAuthor.firstName} {!isMobile && repliesSummary.firstReplyAuthor.lastName}</Box>
                    <Box component="span">ответил</Box>
                    {repliesSummary.count} Ответов
                </Typography>
            </Stack>
        </Stack>
    )
}
